import { when } from 'mobx';
import { once } from '../../js/utils';
import { TIMERS } from '../constants/timers.constant';
import { UITimerStore } from '../UITimerStore';
import { AnalyticsStore } from '../AnalyticsStore';
import { MraidStore } from '../MraidStore';
import { isWeb } from '../../js/environment-utils';

interface AutoCloseHandlerProps {
  uiTimerStore: UITimerStore;
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
}
export class AutoCloseHandler {
  uiTimerStore: UITimerStore;
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;

  constructor({
    uiTimerStore,
    analyticsStore,
    mraidStore
  }: AutoCloseHandlerProps) {
    this.uiTimerStore = uiTimerStore;
    this.analyticsStore = analyticsStore;
    this.mraidStore = mraidStore;
    this.handle = once(this.handle);

    when(
      () => {
        const timer = this.uiTimerStore.timers.get(TIMERS.AUTO_CLOSE_TIMER);
        return Boolean(timer && timer.isFinished);
      },
      () => this.handle()
    );
  }

  handle() {
    this.analyticsStore.sendCreativeTrack('auto_close');
    if (isWeb()) {
      this.mraidStore.forceClose();
    } else {
      this.mraidStore.close();
    }
  }
}
